<template>
    <div class="appletSetting">
        <el-container>
            <el-header>
                <el-row>
                    <el-col :span="12">
                        <div class="title">首页入口配置</div>
                    </el-col>
                    <el-col :span="12">
                       <div class="operatePanel">
                           <el-button
                                   type="primary"
                                   icon="el-icon-upload2"
                                   @click="saveHandle()"
                           >保存配置</el-button>
                       </div>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="8">
                        <div class="headerTxt">角色列表</div>
                    </el-col>
                    <el-col :span="8">
                        <div class="headerTxt">首页入口</div>
                    </el-col>
                </el-row>
                <el-row class="contentBox">
                    <el-col :span="8">
                        <div class="userList listStyle">
                            <div class="userItem" :class="selectIndex== userIndex? 'selectItem':''" v-for="(userItem,userIndex) in userList"
                            :key="'userItem'+ userIndex" @click="setSelectIndex(userIndex)">
                                <div class="userName">{{userItem.name}}</div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="btnList listStyle">
                            <div v-if="selectIndex != -1">
                                <el-checkbox-group v-model="checkedSelect" @change="handleCheckedSelectChange">
                                    <el-checkbox class="userItem"
                                                 v-for="(selectItem, selectIndex) in selectList"
                                                 :key="'selectItem'+selectIndex"
                                                 :disabled="selectItem.name == '小程序菜单'"
                                                 :label="selectItem.id">{{selectItem.name}}</el-checkbox>
                                </el-checkbox-group>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-header>
        </el-container>
    </div>
</template>

<script>
    import {
        getRoleListService,
        getMenuListService,
        getPermissionListService,
    } from '@/services/invoiceServices'
    import {
        changeRoleMenuService,
    } from "../../services/sysSettingService";
    export default {
        name: "appletSetting",
        data(){
            return{
                userList:[],
                selectIndex: -1,
                checkedSelect:[],
                selectList:[]
            }
        },
        methods:{
            onActive(menuCode) {
                this.getRoleList();
                this.getMenuList();
            },
            /**
             * 获取角色列表
             * */
            getRoleList(){
                let paramsData = {
                    pageIndex: 1,
                    pageSize: 10000,
                    type: 'wechat'
                }
                getRoleListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.userList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            getMenuList(){
                let paramsData = {
                    pageIndex: 1,
                    pageSize: 10000,
                    type: 'wechat'
                }
                getMenuListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        this.selectList = res.data;
                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            setSelectIndex(index){
               if(index == this.selectIndex){
                   this.selectIndex = -1
               } else{
                   this.selectIndex = index
                   this.getPermissionList(this.userList[index].id);
               }
            },
            /**
             * 查询角色菜单权限列表
             * */
            getPermissionList(roleId){
                let paramsData = {
                    roleId: roleId,
                }
                getPermissionListService(paramsData).then( res => {
                    if(res.code == 10000000){
                        // this.userSelectList = res.data;
                        if(res.data.length == 0){
                            this.selectList.map(item=> {
                                console.log(item)
                                if(item.name == '小程序菜单'){
                                    this.checkedSelect = [item.id];
                                }
                            })
                        }else{
                            this.checkedSelect = [];
                            res.data.map(item => {
                                this.checkedSelect.push(item.id)
                            })
                        }

                    }else{
                        this.$message.error(res.msg);
                    }
                }).catch(error => {
                    this.$message.error("网络请求失败");
                });
            },
            handleCheckedSelectChange(val){
                console.log(val)
            },
            saveHandle(){
                let roleCode = this.userList[this.selectIndex].id
                let params = [];
                this.checkedSelect.map(item => {
                    params.push({
                        id: item,
                    })
                })
                changeRoleMenuService(params, roleCode).then(
                    res => {
                        // console.log(res);
                        if (res.code == 10000000) {
                            this.$alert("菜单授权成功", "提示");
                            this.isDialogShow = false;
                        } else if (res.code >= 20000000) {
                            this.$alert(res.msg, "提示", {
                                confirmButtonText: "确定"
                            });
                        } else {
                            this.$alert("系统异常", "提示", {
                                confirmButtonText: "确定"
                            });
                        }
                    },
                    err => {
                        this.$message.error("网络请求失败");
                    }
                );
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/commonLayout.scss";

    .appletSetting {
        height: 100%;
        background-color: white;
        display: flex;
        flex-direction: column;
    }
    .title{
        height: 100px;
        display: flex;
        align-items: center;
        padding-left: 50px;
    }
    .headerTxt{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 50px;
        color: #ffffff;
        background: #409eff;
        border-radius: 4px;
        margin-right: 50px;
    }
    .contentBox{
        margin-top: 20px;
    }
    .listStyle{
        height: 600px;
        margin-right: 50px;
        border: 1px solid #409eff;
        border-radius: 4px;
        overflow-y: auto;
    }
    .userItem{
        height: 50px;
        display: flex;
        align-items: center;
        padding-left: 20px;
        cursor: pointer;
    }
    .selectItem{
        background: #a2c8eb;
    }
</style>
